var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconVideoSetDownloadThumbnail = function SvgIconVideoSetDownloadThumbnail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.875,
    clipPath: "url(#icon_video_set_download_thumbnail_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.833 7c0 2.75 0 4.125-.855 4.979-.853.854-2.229.854-4.979.854s-4.124 0-4.979-.854c-.854-.854-.854-2.23-.854-4.979s0-4.125.854-4.98c.855-.853 2.23-.853 4.98-.853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.166 7.292 1.022-.894a1.34 1.34 0 0 1 1.832.06l2.502 2.503a1.17 1.17 0 0 0 1.496.13l.174-.123a1.75 1.75 0 0 1 2.177.132l1.88 1.692"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M9.916 6.417v-5.25m0 5.25 1.75-1.75m-1.75 1.75-1.75-1.75"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_video_set_download_thumbnail_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
};
export default SvgIconVideoSetDownloadThumbnail;